import React from 'react';
import PropTypes from 'prop-types';
import Amount from "components/Display/Amount";

import TransactionKey from "../Display/TransactionKey";


class ReturnStatusResultTable extends React.Component {

  constructor(props){
    super(props);
  }

  render() {

    if (!this.props.data.returnStatus){
      return (
        <div/>
      );
    }

    let returnStatus = this.props.data.returnStatus;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="8" className="text-left">
              <span className="calc-setting-table-header">Útreiknuð skil miðað við stöðu máls og fyrri skil ef til staðar.</span>
            </th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Nú skilað</th>
            <th className="text-right">Inneign</th>
            <th className="text-right">Áður skilað</th>
            <th className="text-right">Afsláttur</th>
            <th className="text-right">Eftirst.</th>
            <th className="text-right">Samtals</th>
            <th className="text-right">Jöfn.</th>
          </tr>
          </thead>
          <tbody>
          {returnStatus.returnSummaries.map((item,i) => {
            if (item.notIncludedInTotal) {
              return;
            }
            return(
                <tr key={i + "before"}>
                  <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                  <td className="text-right"><Amount data={item.returnNow}/></td>
                  <td className="text-right"><Amount data={item.credit}/></td>
                  <td className="text-right"><Amount data={item.previouslyReturned}/></td>
                  <td className="text-right"><Amount data={item.discount}/></td>
                  <td className="text-right"><Amount data={item.remainingAmount}/></td>
                  <td className="text-right"><Amount data={item.totalAmount}/></td>
                  <td className="text-right"><Amount data={item.evenOutAmount}/></td>
                </tr>)
          })}
          <tr className="highlight-principal-future">
            <td className="text-left">Samtals:</td>
            <td className="text-right"><Amount data={returnStatus.totalReturnNow}/></td>
            <td className="text-right"><Amount data={returnStatus.totalCredit}/></td>
            <td className="text-right"><Amount data={returnStatus.totalPreviouslyReturned}/></td>
            <td className="text-right"><Amount data={returnStatus.totalDiscount}/></td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
          </tr>
          {returnStatus.returnSummaries.map((item,i) => {
            if (!item.notIncludedInTotal) {
              return;
            }
            return(
              <tr key={i + "notInTotal"}>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><Amount data={item.returnNow}/></td>
                <td className="text-right"><Amount data={item.credit}/></td>
                <td className="text-right"><Amount data={item.previouslyReturned}/></td>
                <td className="text-right">&nbsp;</td>
                <td className="text-right"><Amount data={item.remainingAmount}/></td>
                <td className="text-right"><Amount data={item.totalAmount}/></td>
                <td className="text-right"><Amount data={item.evenOutAmount}/></td>
              </tr>)
          })}


          </tbody>
        </table>
      </div>
    );
  }
}

ReturnStatusResultTable.propTypes = {
  data: PropTypes.object,
};



export default ReturnStatusResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/ReturnStatusResultTable.js